<template>
  <div>
    <logged-in-header />
    <orders />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import orders from "../components/orders/Orders";

export default {
  components: {
    loggedInHeader,
    orders
  }
};
</script>
